<template>
  <div class="certiciateorder">

    <h1 id="formTitle">Stakeholder certificate application request</h1>

    <form @submit="submitForm" id="submitForm">
      <ol class="questions">
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="applicantName"> <span class="label">Your full name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantName" autocomplete="name" v-model="form.applicantName" name="attributes.applicantName"
                  type="text" required="required" class="stretchWidth" maxlength="255">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="applicantAgency"> <span class="label">Agency you represent</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantAgency" autocomplete="organization" v-model="form.applicantAgency"
                  name="attributes.applicantAgency" type="text" required="required" class="stretchWidth" maxlength="255">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="applicantRole"> <span class="label">Your role in the agency</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantRole" autocomplete="organization-title" v-model="form.applicantRole"
                  name="attributes.applicantRole" type="text" required="required" class="stretchWidth" maxlength="255">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions compact">
              <li class="applicantPreferredContactEmail">
                <label for="applicantPreferredContactEmail"> <span class="label">Email</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantPreferredContactEmail" autocomplete="email"
                  v-model="form.applicantPreferredContactEmail" name="attributes.applicantPreferredContactEmail"
                  type="email" required="required" class="stretchWidth" maxlength="255">
              </li>
              <li class="applicantPreferredContactMobile">
                <label for="applicantPreferredContactMobile">
                  <span class="label">Contact number</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">Mobile preferred</small>
                </label>
                <input id="applicantPreferredContactMobile" autocomplete="tel"
                  v-model="form.applicantPreferredContactMobile" name="attributes.applicantPreferredContactMobile"
                  type="tel" pattern=".{10,}" required="required" class="stretchWidth" maxlength="15">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="applicantRepresentedName"> <span class="label">Applicant name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantRepresentedName" v-model="form.applicantRepresentedName"
                  name="attributes.applicantRepresentedName" type="text" required="required" class="stretchWidth"
                  maxlength="255">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="label">What type of certificate do you want to order?</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices">
              <li>
                <input id="birthCertificate" v-model="form.certificateOrderProduct" value="birthCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="birthCertificate">Birth certificate</label>
              </li>
              <li>
                <input id="deathCertificate" v-model="form.certificateOrderProduct" value="deathCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="deathCertificate">Death certificate</label>
              </li>
              <li>
                <input id="marriageCertificate" v-model="form.certificateOrderProduct" value="marriageCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="marriageCertificate">Marriage certificate</label>
              </li>
              <li>
                <input id="changeOfNameCertificate" v-model="form.certificateOrderProduct" value="changeOfNameCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="changeOfNameCertificate">Change of name certificate</label>
              </li>
              <li>
                <input id="other" v-model="form.certificateOrderProduct" value="other" name="attributes.product"
                  type="radio" required="">
                <label for="other">Other</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.certificateOrderProduct == 'other'">
          <label for="productOther"> <span class="label">Tell us what you want to order</span> <abbr class="required"
              title="(required)">*</abbr></label>
          <input id="productOther" v-model="form.productOther" name="attributes.productOther" type="text"
            required="required" class="stretchWidth" maxlength="255">
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="h3">Upload your documentation</span>
              <div class="status info">
                <p>Supported file types: PDF, JPEG, PNG. </p>
                <p>The maximum file size is 20 MB. </p>
                <p>Do not use special characters (such as apostrophes) and accents in file names.</p>
              </div>
            </legend>

            <ul class="questions">
              <li>
                <legend>
                  <span class="h4 label">Attach the certificate application form</span>
                  <abbr class="required" title="(required)">*</abbr>
                </legend>
                <input id="certFile" @change="handleUpload" type="file" name="certFile" required="true"
                  :accept="uploads.acceptedTypes">
              </li>
              <li>
                <legend>
                  <span class="h4 label">Attach supporting documents</span>
                  <small class="hint">Upload up to 6 supporting document files (e.g. proof of ID documents).</small>
                </legend>
                <fieldset>
                  <table id="supportingDocumentationFiles" class="stretchWidth">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="index in uploads.supportingFiles" :key="index" :id="'supportingDocumentationRow' + index">
                        <td>
                          <input :id="'supportingDocumentation' + index" ref="'supportingDocumentation'+index"
                            @change="handleUpload" type="file" :name="'supportingDocumentation' + index"
                            :accept="uploads.acceptedTypes">
                        </td>
                        <td class="fileProgress">
                        </td>
                        <td v-if="uploadExists('supportingDocumentation' + index)" class="fileOptions">
                          <div class="removeUpload" @click="removeUpload" :targetUpload="'supportingDocumentation' + index">
                            x</div>
                        </td>
                        <td v-else>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </fieldset>
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="description">
                  <span class="label">Any comments to be considered as part of this application</span>
                </label>
                <textarea id="applicantComment" class="stretchWidth" rows="5" v-model="form.applicantComment"
                  name="attributes.applicantComment"></textarea>
              </li>
            </ul>
          </fieldset>
        </li>
        <li id="uploading">
          <p v-if="uploads.uploading > 0">Uploading your attachment... ({{ uploads.uploading }} remaining)</p>
          <p v-else></p>
        </li>
        <li id="inProgress">
          <p v-if="inProgress">Submitting your enquiry...</p>
          <p v-else> </p>
        </li>
        <li>
          <fieldset>
            <ul class="actions">
              <li>
                <strong><button :disabled="uploads.uploading > 0 || inProgress" id="submitButton">Submit
                    application</button></strong>
              </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
    <hr />
  </div>
</template>

<script>
import sppapi from '../../sppapi.js';

export default {
  name: 'TheCerticateOrderForm',
  data: function () {
    return {
      processId: 'orderCertificate',
      form: {
        applicantName: '',
        applicantRepresentedName: '',
        applicantRole: '',
        applicantAgency: '',
        applicantPreferredContactMobile: '',
        applicantPreferredContactEmail: '',
        applicantComment: '',
        productOther: '',
        certificateOrderProduct: ''
      },
      contactPhone: '',
      contactEmail: '',
      uploads: {
        uploadIds: [],
        uploading: 0,
        supportingFiles: 1,
        acceptedTypes: '.jpg, .png, .jpeg, .pdf',
      },
      inProgress: false
    }
  },
  computed: {

  },
  methods: {
    removeUpload: function (event) {
      event.preventDefault()
      let targetUploadId = event.target.attributes['targetUpload'].value
      document.getElementById(targetUploadId).value = ''
      this.uploads.uploadIds = this.uploads.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
      return false
    },
    uploadExists: function (fieldId) {
      return this.uploads.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
    },
    handleUpload: function (event) {
      const selection = event.target.files[0]
      const ext = selection.name.split('.').pop();
      if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
        document.getElementById(event.target.id).value = ''
        return
      }

      this.uploads.uploading++
      const reader = new FileReader()
      reader.onload = (e) => {
        sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
        if (event.srcElement.name != "certFile" && this.uploads.supportingFiles < 6) {
          this.uploads.supportingFiles++
        }
      }
      reader.readAsDataURL(selection)
    },
    submitForm: function (event) {
      event.preventDefault();
      this.contactPhone = this.form.applicantPreferredContactMobile;
      this.contactEmail = this.form.applicantPreferredContactEmail;

      if (this.form.applicantPreferredContactMobile.length < 10) {
        return
      }

      if (this.uploads.uploadIds.length == 0) {
        return
      }
      if (this.form.product == '' || this.form.applicantName == '' || this.form.applicantRole == '' || this.applicantRepresentedName == ''
        || this.form.applicantAgency == '' || this.form.applicantPreferredContactEmail == '' || this.form.applicantPreferredContactMobile == '') {
        return
      }
      if (this.form.certificateOrderProduct == 'other' && this.form.productOther == '') {
        return
      }
      if (this.form.certificateOrderProduct == '') {
        return
      }

      sppapi.startProcessAndCompleteTask(this);
    }
  },
  components: {
  }
}

</script>

<style scoped lang="scss">
#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.applicantPreferredContactEmail {
  width: 100%;
}

#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}
</style>
